import { render } from "./ImportantDevices.vue?vue&type=template&id=34d2398a"
import script from "./ImportantDevices.vue?vue&type=script&lang=js"
export * from "./ImportantDevices.vue?vue&type=script&lang=js"

import "./ImportantDevices.vue?vue&type=style&index=0&id=34d2398a&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__